import { ScrollCaptain } from 'scroll-captain';
import './contact.scss';

class contact {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-contact',
            itemValue: 'item',
            breakpoint: 1023
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$$items = this.$root.querySelectorAll(`[${this.settings.initAttr}^="${this.settings.itemValue}"]`);

        // Properties
        this.animation = null;
        this.breakpoint = window.matchMedia(`(max-width: ${this.settings.breakpoint}px)`);
        this.breakpointActive = this.breakpoint.matches;
        this.multiplier = window.reducedMotionActive ? 0 : 1;
    }

    initialize () {
        this.setEvents();
    }

    initialize () {
        this.loadAnimation();
        this.setEvents();
    }

    // Configure and load animations with ScrollCaptain
    loadAnimation () {
        let animationOptions = {
            initAttr: this.settings.initAttr,
            updateOnResize: () => {
                if (this.breakpoint.matches !== this.breakpointActive) {
                    this.breakpointActive = this.breakpoint.matches;
                    this.updateAnimation(false);
                }
            }
        };

        // Set up individual animations for each item
        this.$$items.forEach(($item, index) => {
            const key = `animateTile${index + 1}`;

            animationOptions[key] = {
                targetSuffix: `${this.settings.itemValue}-${index + 1}`,
                onscroll: true,
                translateX: this.breakpoint.matches ? null : { 0: 150 * (index + 1) * this.multiplier, 50: 0, 100: 0 }
            };
        });

        this.animation = new ScrollCaptain(this.$root, animationOptions);
    }

    updateAnimation (updateRequired) {
        // Set up individual animations for each item
        this.$$items.forEach(($item, index) => {
            const key = `animateTile${index + 1}`;
            this.animation.defaultOptions[key].translateX = this.breakpoint.matches ? null : { 0: 150 * (index + 1) * this.multiplier, 50: 0, 100: 0 };
        });

        if (updateRequired) {
            this.animation.update();
        }
    }

    setEvents () {
        window.addEventListener('motionPreferenceChanged', () => {
            this.multiplier = window.reducedMotionActive ? 0 : 1;
            this.updateAnimation(true);
        });
    }
}

export { contact };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-contact="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new contact($root);
            $rootAPI.initialize();
        });
    }
});
